import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

declare var $: any;

@Component({
    selector: 'ups-dashboard-accordeon-qv',
    template: require('./ups-dashboard-accordeon-qv.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsDashboardAccordeonQVComponent implements OnInit {

    @Input() display: string = '';
    public _display: string = '';
    public ham: boolean = false;

    ngOnInit() {

    }


}


